// src/pages/dataTest.js
// Upload ➜ preview signed‑URL ➜ delete   (private objects – Amplify v6 “path” syntax)

import React, { useState } from 'react';
import { uploadData, getUrl, remove } from 'aws-amplify/storage';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';


const DataTest = () => {
  
  const [file, setFile] = useState(null);     // selected <input> file
  const [obj,  setObj]  = useState(null);     // { path, url } of last upload
  const [busy, setBusy] = useState(false);    // disables UI while working

  /* ---------- upload + sign ---------- */
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || busy) return;
    setBusy(true);

    try {
      await getCurrentUser();                         // ensure signed‑in
      const { identityId } = await fetchAuthSession();

      /* Build the exact path your IAM policy permits */
      const path = `private/${identityId}/${file.name}`;

      /* 1️⃣ upload */
      await uploadData({
        path,
        data: file,
        options: { contentType: file.type }           // no accessLevel field
      }).result;

      /* 2️⃣ presign */
      const { url } = await getUrl({
        path,
        options: { expiresIn: 3600 }                  // 1 hour
      });

      /* 3️⃣ show card */
      setObj({ path, url: url.toString() });
      setFile(null);
    } catch (err) {
      console.error('Upload error:', err);
    } finally {
      setBusy(false);
    }
  };

  /* ---------- delete ---------- */
  const handleDelete = async () => {
    if (!obj) return;
    try {
      await remove({ path: obj.path });               // path already includes prefix
      setObj(null);
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  /* ---------- UI ---------- */
  return (
    <div className="max-w-xl mx-auto p-6 space-y-8">
      <h1 className="text-2xl font-semibold">S3 Image Test (private)</h1>

      {/* upload form */}
      <form onSubmit={handleUpload} className="flex gap-4">
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          className="flex-1"
        />
        <button
          type="submit"
          disabled={!file || busy}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          {busy ? 'Uploading…' : 'Upload'}
        </button>
      </form>

      {/* preview card */}
      {obj ? (
        <div className="relative group border rounded-lg p-4 space-y-3 shadow">
          <img
            src={obj.url}
            alt={obj.path.split('/').pop()}
            className="w-full h-60 object-cover rounded"
          />
          <div className="break-all text-xs text-gray-700">{obj.url}</div>

          <button
            onClick={handleDelete}
            className="absolute top-2 right-2 px-3 py-1 text-xs bg-red-600
                       text-white rounded opacity-0 group-hover:opacity-100"
          >
            Delete
          </button>
        </div>
      ) : (
        <p className="text-center text-gray-500">
          Upload an image to generate its private URL.
        </p>
      )}
    </div>
  );
};

export default DataTest;
